import { Table, Button, Card, Space, Tag, Statistic, Empty } from "antd";
import { DownloadOutlined, UserOutlined } from "@ant-design/icons";

export default function SegmentPreview({ data, loading, onExport }) {
  // Safely handle data - ensure it's always an array
  const safeData = Array.isArray(data) ? data : [];

  const columns = [
    {
      title: "User ID",
      dataIndex: "userId",
      key: "userId",
    },
    {
      title: "Name",
      dataIndex: "userName",
      key: "userName",
    },
    {
      title: "Email",
      dataIndex: "emailId",
      key: "emailId",
    },
    {
      title: "Opted In",
      dataIndex: "optedIn",
      key: "optedIn",
      render: (optedIn) => (
        <Tag color={optedIn ? "green" : "red"}>{optedIn ? "Yes" : "No"}</Tag>
      ),
    },
    {
      title: "Created",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (date) => (date ? new Date(date).toLocaleDateString() : "-"),
    },
  ];

  // Safe filtering with array check
  const stats = {
    total: safeData.length,
    optedIn: Array.isArray(safeData)
      ? safeData.filter((u) => u.optedIn).length
      : 0,
  };

  return (
    <div style={{ zIndex: "100000" }}>
      {/* Stats Bar */}
      <div style={{ marginBottom: 16 }}>
        <Space>
          <Card size="small">
            <Statistic
              title="Total Users"
              value={stats.total}
              prefix={<UserOutlined />}
            />
          </Card>
          <Card size="small">
            <Statistic
              title="Opted In"
              value={stats.optedIn}
              suffix={`/ ${stats.total}`}
            />
          </Card>
        </Space>
      </div>

      {/* Export Button */}
      <div style={{ marginBottom: 16, textAlign: "right" }}>
        <Button
          type="primary"
          icon={<DownloadOutlined />}
          onClick={onExport}
          disabled={safeData.length === 0}
        >
          Export as CSV
        </Button>
      </div>

      {/* Users Table or Empty State */}
      {safeData.length > 0 ? (
        <Table
          columns={columns}
          dataSource={safeData}
          rowKey={(record) => record._id || record.userId || Math.random()}
          loading={loading}
          pagination={{ pageSize: 10 }}
          scroll={{ x: true }}
        />
      ) : (
        <Empty
          description={
            loading ? "Loading users..." : "No users found in this segment"
          }
          image={Empty.PRESENTED_IMAGE_SIMPLE}
        />
      )}
    </div>
  );
}
